import React from 'react';
import { Link, useParams } from 'react-router';
import { PageHero } from '../components/PageHero';
import { Section } from '../components/Section';
import { Button } from '../components/Button';
import useTheme from '../hooks/useTheme';
import { megaGreenData } from '../data/data';

export const InsightDetail: React.FC = () => {
    const { theme, breakpoint } = useTheme();
    const { slug } = useParams<{ slug: string }>();

    const article = megaGreenData.insights.articles.find(a => a.slug === slug);
    if (!article) {
        return (
            <div style={{ padding: '48px', textAlign: 'center' }}>
                <h1>Insight not found</h1>
                <Link to="/insights">Back to Insights</Link>
            </div>
        );
    }

    return (
        <>
            <PageHero
                title={article.title}
                subtitle={article.deck}
            />

            <Section>
                <div
                    style={{
                        display: 'flex',
                        gap: '16px',
                        flexWrap: 'wrap',
                        marginBottom: '32px',
                    }}
                >
                    <Link to="/contact" style={{ textDecoration: 'none' }}>
                        <Button variant="primary">Request a Consultation</Button>
                    </Link>
                    <Link to="/insights" style={{ textDecoration: 'none' }}>
                        <Button variant="secondary">Back to Insights</Button>
                    </Link>
                </div>

                <img src={article.src} alt={article.title} style={{
                    width: '100%', height: breakpoint.xs || breakpoint.sm ? 300 : 500,
                    marginBottom: '32px',
                    borderRadius: theme.borderRadius.r1,
                    objectFit: 'cover',
                }} />

                <div
                    style={{
                        margin: '0 auto',
                    }}
                >
                    <div
                        style={{
                            fontSize: '16px',
                            color: theme.text.muted,
                            lineHeight: 1.6,
                            marginBottom: '32px',
                        }}
                    >
                        {article.body.split('\n').map((paragraph, idx) => (
                            <p key={idx} style={{ marginBottom: '16px' }}>
                                {paragraph}
                            </p>
                        ))}
                    </div>

                    {/* {article.suggestedVisuals && article.suggestedVisuals.length > 0 && (
                        <div>
                            <h2
                                style={{
                                    fontSize: breakpoint.xs || breakpoint.sm ? '28px' : '34px',
                                    fontWeight: 700,
                                    color: theme.text.primary,
                                    marginBottom: '16px',
                                }}
                            >
                                Suggested visuals
                            </h2>
                            <ul
                                style={{
                                    listStyle: 'none',
                                    padding: 0,
                                    margin: 0,
                                    display: 'flex',
                                    flexDirection: 'column',
                                    gap: '12px',
                                }}
                            >
                                {article.suggestedVisuals.map((visual, idx) => (
                                    <li
                                        key={idx}
                                        style={{
                                            fontSize: '16px',
                                            color: theme.text.muted,
                                            display: 'flex',
                                            alignItems: 'flex-start',
                                            gap: '12px',
                                        }}
                                    >
                                        <span style={{ color: theme.palette.primary.main, marginTop: '4px', flexShrink: 0 }}>•</span>
                                        {visual}
                                    </li>
                                ))}
                            </ul>
                        </div>
                    )} */}
                </div>
            </Section>

            <Section
                style={{
                    backgroundColor: theme.background.panel,
                }}
            >
                <div
                    style={{
                        maxWidth: '800px',
                        margin: '0 auto',
                        textAlign: 'center',
                    }}
                >
                    <h2
                        style={{
                            fontSize: breakpoint.xs || breakpoint.sm ? '28px' : '34px',
                            fontWeight: 700,
                            color: theme.text.primary,
                            marginBottom: '16px',
                        }}
                    >
                        Tell us what you're planning
                    </h2>
                    <p
                        style={{
                            fontSize: '16px',
                            color: theme.text.muted,
                            marginBottom: '24px',
                        }}
                    >
                        {megaGreenData.contact.pageIntro}
                    </p>
                    <Link to="/contact" style={{ textDecoration: 'none' }}>
                        <Button variant="primary" style={{ padding: '12px 32px' }}>
                            Request a Consultation
                        </Button>
                    </Link>
                </div>
            </Section>
        </>
    );
};

